import Button from '@material-ui/core/Button'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import { specialTheme } from '../theme'

const useStyles = makeStyles((theme) => ({
  button: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: specialTheme.font.fontFSMe,
    color: specialTheme.colors.dark,
    backgroundColor: specialTheme.colors.white,
    '&:hover': {
      backgroundColor: specialTheme.colors.white,
    },
    textTransform: 'initial',
    borderRadius: 0,
  },
}))

const BanButton = ({
  children,
  onClick,
}: {
  children: React.HTMLProps<HTMLButtonElement>
  onClick: () => void
}) => {
  const classes = useStyles()
  return (
    <Button type="button" className={classes.button} onClick={onClick}>
      {children}
    </Button>
  )
}

export default BanButton
